// extracted by mini-css-extract-plugin
export var buttons = "_4g-0";
export var buttonsActive = "_4g-h";
export var cancelConfirm = "_4g-1";
export var closeButton = "_4g-2";
export var column = "_4g-3";
export var container = "_4g-4";
export var detailHeader = "_4g-6";
export var detailTitle = "_4g-7";
export var detailsContent = "_4g-5";
export var header = "_4g-8";
export var headerWithClose = "_4g-9";
export var icon = "_4g-a";
export var infoIcon = "_4g-c";
export var informationContainer = "_4g-b";
export var sideDrawer = "_4g-d";
export var sideDrawerOpen = "_4g-e";
export var stickyFooter = "_4g-f";
export var typeOption = "_4g-g";